import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { getAboutList } from "../../services/about/about.service";
import { IMAGE_BASE_URL } from "../../services/base.service";
import ReactBootstrapCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import Title from "../../components/title";
import styles from "./about.module.css";
import { getHeaderList } from "../../services/header/header.service";
import { toast, ToastContainer } from "react-toastify";
const formFieldStatus = {
  valid: 1,
  unvalid: 2,
  untouched: 3,
};
const initialValidationResult = {
  fullName: { status: formFieldStatus.untouched, errors: [] },
  email: { status: formFieldStatus.untouched, errors: [] },
  message: { status: formFieldStatus.untouched, errors: [] },
};
const About = () => {
  const navigate = useNavigate();
  const imgRef = useRef();
  const [loading, setIsLoading] = useState(false);
  const [aboutList, setAboutList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [tabContent, setTabContent] = useState(null);
  const [activeId, setActiveId] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const messageRef = useRef();
  const emailRef = useRef();
  const fullNameRef = useRef();
  const tabIndex = query.get("t");
  const [validationResult, setValidationResult] = useState({
    ...initialValidationResult,
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("با موفقیت ثبت شد!");
    setDisabledBtn(true);
    setValidationResult({ ...initialValidationResult });
    emailRef.current.value = "";
    fullNameRef.current.value = "";
    messageRef.current.value = "";
  };
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const validateMessage = (message) => {
    return (
      !String(message)
        .toLowerCase()
        .match(/^[\u0600-\u06FFa-zA-Z0-9-_.،'"\s]+$/) ||
      message.indexOf('"') >= 0 ||
      message.indexOf("'") >= 0
    );
  };
  const validateName = (name) => {
    return String(name)
      .toLowerCase()
      .match(/^[\u0600-\u06FF\s]+$/);
  };
  const handleFormChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "email") {
      if (validateEmail(value)) {
        setValidationResult({
          ...validationResult,
          email: { status: formFieldStatus.valid, errors: [] },
        });
      } else {
        if (value.length === 0) {
          setValidationResult({
            ...validationResult,
            email: {
              status: formFieldStatus.unvalid,
              errors: ["اجباری"],
            },
          });
        } else {
          setValidationResult({
            ...validationResult,
            email: {
              status: formFieldStatus.unvalid,
              errors: ["ایمیل مورد نظر صحیح نمیباشد."],
            },
          });
        }
      }
    } else if (name === "fullName") {
      if (value.length === 0) {
        setValidationResult({
          ...validationResult,
          fullName: {
            status: formFieldStatus.unvalid,
            errors: ["اجباری"],
          },
        });
      } else if (value.length <= 2) {
        setValidationResult({
          ...validationResult,
          fullName: {
            status: formFieldStatus.unvalid,
            errors: ["حداقل تعداد کاراکتر ۲ است"],
          },
        });
      } else {
        if (!validateName(value)) {
          setValidationResult({
            ...validationResult,
            fullName: {
              status: formFieldStatus.unvalid,
              errors: ["نام فقط باید کاراکتر های فارسی باشد"],
            },
          });
        } else {
          setValidationResult({
            ...validationResult,
            fullName: { status: formFieldStatus.valid, errors: [] },
          });
        }
      }
    } else if (name === "message") {
      if (value.length === 0) {
        setValidationResult({
          ...validationResult,
          message: {
            status: formFieldStatus.unvalid,
            errors: ["اجباری"],
          },
        });
      } else if (value.length <= 5) {
        setValidationResult({
          ...validationResult,
          message: {
            status: formFieldStatus.unvalid,
            errors: ["حداقل تعداد کاراکتر ۵ است"],
          },
        });
      } else {
        if (validateMessage(value)) {
          setValidationResult({
            ...validationResult,
            message: {
              status: formFieldStatus.unvalid,
              errors: ["در متن پیام از کارکترهای غیرمجاز استفاده شده است."],
            },
          });
        } else {
          setValidationResult({
            ...validationResult,
            message: { status: formFieldStatus.valid, errors: [] },
          });
        }
      }
    }
  };
  useEffect(() => {
    const ObjectKeys = Object.keys(validationResult);
    let shouldDisable = false;
    for (let key of ObjectKeys) {
      if (validationResult[key].status !== formFieldStatus.valid) {
        shouldDisable = true;
      }
    }
    setDisabledBtn(shouldDisable);
  }, [validationResult]);
  const toggleModal = (e) => {
    setShowModal(true);

    let elSrc = null;

    if (e.target.hasAttribute("src")) {
      elSrc = e.target.src;
    } else {
      elSrc = e.target.querySelector("img").src;
    }

    setTimeout(() => {
      document.getElementById("modal-about-source").src = elSrc;
    }, 10);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  function handleAccordeonClick() {
    const accordeonHeader = document.querySelectorAll(".accordeon-header");
    accordeonHeader.forEach((item) => {
      item.addEventListener("click", function (e) {
        const parentNode = e.target.parentNode;
        const toggleBtn = parentNode.querySelector(".toggle-btn");
        if (toggleBtn.innerText.indexOf("+") >= 0) {
          toggleBtn.innerText = "-";
        } else {
          toggleBtn.innerText = "+";
        }
        const dropdown = parentNode.querySelector(".dropdown");
        if (dropdown.style.display === "none") {
          dropdown.style.display = "block";
        } else {
          dropdown.style.display = "none";
        }
      });
    });
  }
  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "درباره ما", url: "/about" },
    ]);
    setIsLoading(true);
    getHeaderList().then((data) => {
      const aboutMenu = (data && data.data && data.data.data) || [];
      let parentMenu = {};
      for (const menu of aboutMenu) {
        if (Array.isArray(menu.children) && menu.children.length > 0) {
          for (let child of menu.children) {
            if (
              child.children &&
              Array.isArray(child.children) &&
              child.children.length > 0
            ) {
              const grandChildren = child.children;
              for (let grandChild of grandChildren) {
                if (
                  grandChild.destination_url &&
                  grandChild.destination_url.startsWith("/about")
                ) {
                  parentMenu = { ...menu };
                  break;
                }
              }
            }
          }
        }
      }
      setMenuItems(parentMenu.children || []);
    });
    getAboutList().then(({ data }) => {
      setIsLoading(false);
      let tmpData = data && data.data;
      setAboutList(tmpData || []);
      if (window.location.href.indexOf("?t=") >= 0) {
        const tIndex = window.location.href.split("?t=")[1];
        if (tIndex) {
          const filteredData = tmpData.find(
            (d) =>
              d.guid === tabIndex ||
              (d?.slug || "").toLowerCase() === tabIndex.toLowerCase()
          );
          if (filteredData && filteredData.context) {
            setTabContent(filteredData.context);
          } else {
            setTabContent("");
          }
          handleAccordeonClick();
          setActiveId(tIndex);
        } else {
          let replacedImageText;
          if (Array.isArray(tmpData) && tmpData.length > 0) {
            replacedImageText = tmpData[0]?.context;
          }
          setTabContent(replacedImageText);
          handleAccordeonClick();
          setActiveId(tabIndex);
        }
      } else {
        try {
          if (!tabIndex) {
            setTabContent(tmpData[0]?.context);
            handleAccordeonClick();
            setActiveId(tabIndex);
          } else {
            const filteredData = tmpData.find(
              (data) =>
                data.guid === tabIndex ||
                data.toLowerCase() === tabIndex.toLowerCase()
            );
            setTabContent(filteredData?.context);
            handleAccordeonClick();
            setActiveId(tabIndex);
          }
        } catch (e) {}
      }
    });
  }, [tabIndex]);
  useEffect(() => {
    if (window.location.href.indexOf("?t=") >= 0) {
      const tIndex = window.location.href.split("?t=")[1];
      setActiveId(tIndex);
    }
  }, []);
  const changeTab = (index) => {
    navigate("/about" + "?t=" + index);
  };
  return (
    <>
      <Title title={"درباره ما"} />
      {showModal ? (
        <>
          <div id={styles.modalBackdrop} onClick={closeModal}></div>
          <div id={styles.modalWrapper}>
            <div className={"modal-close"} onClick={closeModal}>
              &#x2715;
            </div>
            <img
              src={""}
              id="modal-about-source"
              ref={imgRef}
              alt={"about source"}
            />
          </div>
        </>
      ) : null}
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />

        <div className={`row ${styles.wrapper}`}>
          {loading && (
            <div className={styles.loading}>
              <img
                src={"../../../assets/image/loading.svg"}
                alt={"در حال بار گذاری"}
              />
            </div>
          )}
          <div className={"col-xs-12 col-md-9"}>
            {activeId === "violationReport" || activeId === "contactWithBOD" ? (
              <div className={styles.form} id={styles.tabContent}>
                <div className="row">
                  <form onSubmit={handleSubmit}>
                    <div className="col-xs-12">
                      <h1 className={styles.headerForm}>
                        {activeId === "violationReport"
                          ? "ثبت نقض قوانین و مقررات"
                          : "ارتباط سهامداران با هیئت مدیره"}
                      </h1>
                    </div>
                    <div className="col-xs-6">
                      <label htmlFor="email">
                        پست الکترونیک{" "}
                        <span className={styles.starIcon}>(*)</span>
                      </label>
                      <input
                        onChange={handleFormChange}
                        id="email"
                        name="email"
                        ref={emailRef}
                        className={`form-control ${styles.formControlItem}`}
                      />
                      {validationResult.email.errors.length > 0 && (
                        <div className={styles.errorMessage}>
                          {validationResult.email.errors[0]}
                        </div>
                      )}
                    </div>
                    <div className="col-xs-6">
                      <label htmlFor="fullName">
                        نام و نام خانوادگی{" "}
                        <span className={styles.starIcon}>(*)</span>
                      </label>
                      <input
                        onChange={handleFormChange}
                        id="fullName"
                        name="fullName"
                        ref={fullNameRef}
                        className={`form-control ${styles.formControlItem}`}
                      />
                      {validationResult.fullName.errors.length > 0 && (
                        <div className={styles.errorMessage}>
                          {validationResult.fullName.errors[0]}
                        </div>
                      )}
                    </div>
                    <div className="col-xs-12">
                      <label htmlFor="message">
                        پیام <span className={styles.starIcon}>(*)</span>
                      </label>
                      <textarea
                        onChange={handleFormChange}
                        id="message"
                        name="message"
                        ref={messageRef}
                        rows="7"
                        className={`form-control ${styles.formControlItem}`}
                      ></textarea>
                      {validationResult.message.errors.length > 0 && (
                        <div className={styles.errorMessage}>
                          {validationResult.message.errors[0]}
                        </div>
                      )}
                    </div>
                    <div className="clearfix" />
                    <div className="col-xs-12">
                      <button
                        className={styles.submitBtn}
                        type="submit"
                        disabled={disabledBtn}
                      >
                        <i className="fa fa-paper-plane" />
                        ثبت
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : tabContent ? (
              <>
                <div id={styles.tabContent}>
                  {aboutList &&
                  aboutList.length > 0 &&
                  aboutList.find(
                    (item) =>
                      item.guid === activeId ||
                      (item?.slug || "").toLowerCase() ===
                        (activeId || "").toLowerCase()
                  )?.attachment_files.length > 0 ? (
                    <div className={styles.aboutImageWrapper}>
                      {aboutList[activeId]?.attachment_files.length > 1 ? (
                        <ReactBootstrapCarousel>
                          {aboutList[activeId]?.attachment_files.map(
                            (item, index) => (
                              <div
                                className={"el-wrapper"}
                                onClick={(e) => toggleModal(e)}
                              >
                                <SliderElem
                                  item={item}
                                  key={index + "-slider-main-elem"}
                                  isActive={index === 0 ? true : false}
                                />
                              </div>
                            )
                          )}
                        </ReactBootstrapCarousel>
                      ) : (
                        <>
                          <img
                            src={
                              aboutList.find(
                                (item) =>
                                  item.guid === activeId ||
                                  (item?.slug || "").toLowerCase() ===
                                    (activeId || "").toLowerCase()
                              )?.attachment_files[0]?.server_relative_url
                            }
                            alt={"about"}
                          />
                        </>
                      )}
                    </div>
                  ) : null}
                  <div dangerouslySetInnerHTML={{ __html: tabContent }}></div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div className={"col-xs-12 col-md-3"}>
            <h2 className={styles.sidebarAboutTitle}>درباره ما</h2>
            {Array.isArray(menuItems) && menuItems.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {menuItems.map((item, index) => (
                  <li
                    className={item.guid === activeId ? styles.active : null}
                    key={index + "-key-tab-box"}
                  >
                    <div>{item.title}</div>
                    <ul className={styles.subMenuAbout}>
                      {item.children.map((child, index) => (
                        <li
                          className={
                            child.destination_url.split("?t=")[1] === activeId
                              ? styles.active
                              : null
                          }
                          onClick={() =>
                            changeTab(child.destination_url.split("?t=")[1])
                          }
                          key={index + "-key-tab-box"}
                        >
                          <div>{child.title}</div>
                          <i className="fa fa-angle-left" />
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            ) : (
              <></>
            )}
            <ToastContainer />
          </div>
        </div>
      </div>
    </>
  );
};
const SliderElem = ({ item, isActive }) => {
  return (
    <div
      className={
        isActive
          ? `${styles.item} ${styles.active} ${styles.aboutCarousel}`
          : `${styles.item} ${styles.aboutCarousel}`
      }
    >
      <img src={item.server_relative_url} alt={"about carousel"} />
    </div>
  );
};
export default About;
